import { render, staticRenderFns } from "./FileUploadContainer.vue?vue&type=template&id=5bc40e6b&scoped=true"
import script from "./FileUploadContainer.vue?vue&type=script&lang=js"
export * from "./FileUploadContainer.vue?vue&type=script&lang=js"
import style0 from "./FileUploadContainer.vue?vue&type=style&index=0&id=5bc40e6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc40e6b",
  null
  
)

export default component.exports